export default {
  editor_button_text_placeholderRequestNumber: 'Pedir N\u00famero',
  contactCard_default_status:
    'Ainda n\u00e3o est\u00e1 no flock - mas voc\u00ea pode enviar uma mensagem para se aproximar',
};
